import React from 'react';
import { withRouter } from 'react-router-dom';

import InnerBox from '../InnerBox/InnerBox';
import {
  ListElement,
  Title,
  StyledLine,
  StyledLineInside,
  Image,
  FlexContainer
} from '../StyledComponents';
import { SideBar } from '../StyledComponents/StyledSideBar';
import { SpecsSideBar } from '../StyledComponents/SpecsSideBar';
import AdBanner from '../AdBanner/AdBanner';
import adAmazonVertical from '../../../assets/images/ad-amazon-vertical.png';
import adLinkedin from '../../../assets/images/ad-linkedin.png';
import adSeparator from '../../../assets/images/ad-separator.png';

const createMarkup = content => {
  return { __html: content };
};

const Specifications = props => {
  // console.log('props: ', props);
  const { specs, keySpecs, history } = props;
  let sections;

  // galleryClickHandler = e => {
  //   const targetLink = e.target.closest('a');
  //   if (!targetLink) return;
  //   e.preventDefault();

  //   console.log(targetLink.href);
  //   // console.log(targetLink.href.slice(22));

  //   // this.props.history.push(e.target.href);
  // };

  const contentClickHandler = e => {
    // console.log(`Specifications ContentClickHandler`, e);
    const targetLink = e.target.closest('a');
    console.log('targetLink: ', targetLink);
    console.log('targetLink.protocol: ', targetLink.protocol);
    console.log('targetLink.host: ', targetLink.host);
    console.log('targetLink.hostname: ', targetLink.hostname);
    console.log('targetLink.port: ', targetLink.port);
    console.log('targetLink.pathname: ', targetLink.pathname);
    console.log('targetLink.hash: ', targetLink.hash);
    console.log('targetLink.search: ', targetLink.search);
    if (!targetLink) return;
    e.preventDefault();
    e.stopPropagation();
    // let slug = targetLink.href.substr(targetLink.href.lastIndexOf('/') + 1);

    let slug = targetLink.pathname.slice(1);
    if (slug === 'old-gallery') {
      // history.push(`/old-gallery`);
      // if (targetLink.pathname === '/old-gallery') {
      let oldGallerySlug = targetLink.getAttribute('data-ids');
      // console.log('oldGallerySlug: ', oldGallerySlug);
      history.push({
        // pathname: targetLink.pathname.slice(1),
        pathname: slug,
        state: `change`,
        oldGallerySlug: oldGallerySlug
      });
    } else {
      history.push(`/gallery/${slug}/0`);
    }
  };

  sections = specs.map((section, index) => {
    // console.log('index: ', index);
    // console.log('section: ', section);
    return (
      <div
        className="Specfications w-100 flex flex-column items-center"
        key={section.title}
      >
        {/* {section.title.toLowerCase().includes('hardware') ||
        section.title.toLowerCase().includes('camera') ? ( */}
        {section.skill_featured_image ? (
          <FlexContainer
            style={{
              width: '100%',
              height: 'auto',
              // maxHeight: '720px',
              maxHeight: '1080px',
              overflow: 'hidden',
              alignItems: 'center'
              // maxWidth: '1440px'
            }}
          >
            {/* {section.skill_featured_image ? ( */}
            <Image
              src={section.skill_featured_image}
              width="100%"
              height="100%"
              alt={section.title}
            />
            {/* ) : null} */}
          </FlexContainer>
        ) : null}
        <InnerBox className="flex-column-m flex-column flex-row-l">
          <ListElement>
            <Title
              className="mt3"
              fontFamily="Montserrat"
              fontSize="2.25rem"
              fontWeight="bold"
              color="#4a4a4a"
              id={section.title.toLowerCase()}
            >
              {section.title}
            </Title>
            <StyledLine margin="10px 0 15px 0">
              <StyledLineInside />
            </StyledLine>
            <Title
              fontFamily="Montserrat"
              fontSize="1rem"
              fontWeight="normal"
              letterSpacing="0px"
              lineHeight="30px"
              color="#4a4a4a"
              dangerouslySetInnerHTML={createMarkup(section.description)}
              onClick={contentClickHandler}
            />

            {section.title !== 'SCORES' ? (
              index % 3 === 0 ? (
                <AdBanner height="250px" width="300px" margin="1rem 0 1rem 0">
                  <Image
                    src={adLinkedin}
                    width="100%"
                    height="100%"
                    alt="tissot ad"
                  />
                </AdBanner>
              ) : (
                <AdBanner height="91px" width="730px" margin="1rem 0 1rem 0">
                  <Image
                    src={adSeparator}
                    width="100%"
                    height="100%"
                    alt="tissot ad"
                  />
                </AdBanner>
              )
            ) : null}
          </ListElement>
          {section.title !== 'SCORES' ? (
            index === 0 ? (
              <SpecsSideBar>
                <div style={{ background: '#f3f4f6', padding: '14px' }}>
                  <Title
                    fontFamily="Montserrat"
                    fontSize="1.5rem"
                    fontWeight="bold"
                    color="#222222"
                  >
                    Key Specs
                  </Title>
                  <StyledLine margin="10px 0 15px 0">
                    <StyledLineInside />
                  </StyledLine>
                  <Title
                    className="key-specs"
                    fontFamily="Montserrat"
                    fontSize="1rem"
                    fontWeight="normal"
                    letterSpacing="0px"
                    lineHeight="22px"
                    color="#2c2c2c"
                    marginforp="0 0 10px 0"
                    dangerouslySetInnerHTML={createMarkup(keySpecs)}
                    onClick={contentClickHandler}
                  />
                </div>
              </SpecsSideBar>
            ) : (
              <SideBar>
                <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                  <Image
                    src={adAmazonVertical}
                    width="100%"
                    height="100%"
                    alt="adAmazonVertical"
                  />
                </AdBanner>
              </SideBar>
            )
          ) : (
            <SideBar>
              <div
                width="100%"
                height="100%"
                style={{ visibility: 'hidden' }}
              />
            </SideBar>
          )}
        </InnerBox>
      </div>
    );
  });
  return (
    <FlexContainer direction="column" alignitems="center" className="w-100">
      {sections}
    </FlexContainer>
  );
};

export default withRouter(Specifications);
